import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCivilUnionCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Annullamento Unione Civile',
    path: '/mutazioni/cerca-persona/unione-civile',
  },
];

export const CancelCivilUnionCrumbs = [
  ...SearchPersonCivilUnionCrumbs,
  {
    name: 'Annullamento Unione Civile',
    path: '/mutazioni/cerca-persona/unione-civile/scioglimento',
  },
];
